// extracted by mini-css-extract-plugin
export default {"modalOverlay":"mJ-z","modalContent":"nJ-z","header":"oJ-z","close":"pJ-z"};